import type { FieldMergeFunction } from '@apollo/client/cache/inmemory/policies';

export const merge: FieldMergeFunction = <T = Record<string, unknown>>(
  existing: T,
  incoming: T,
) => ({
  ...existing,
  ...incoming,
});
